import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { GeneralContentsState } from './reducer';

export const getErrors = (state: RootState) => state.generalContents.errors;

export const getGeneralContents = (state: RootState) => state.generalContents;

export const getItems = createSelector(
  getGeneralContents,
  (state: GeneralContentsState) => state.items,
);

export const getIsFetching = createSelector(
  getGeneralContents,
  (state: GeneralContentsState) => state.isFetching,
);
